export default __webpack_public_path__ + "images/dcb06f7d06aff49ae36f63e1da182aa2.png";